const openPredictiveSearch = document.querySelectorAll('[data-predictive-search-open]');
const closePredictiveSearch = document.querySelector('[data-predictive-search-close]');

const predictiveSearch = document.querySelector('[data-predictive-search]');

const predictiveSearchInputs = document.querySelectorAll('[data-predictive-search-input]');
const predictiveSearchInputClear = document.querySelector('[data-predictive-search-input-clear]');

const predictiveSearchResultWrapper = document.querySelectorAll('[data-predictive-search-results]');
const predictiveSearchOverlay = document.querySelector('[data-predictive-search-overlay]');

const predictiveSearchSuggestions = document.querySelector('[data-predictive-search-suggestions]');

function debounce(func, delay) {
  let debounceTimer
  return function () {
    const context = this
    const args = arguments
    clearTimeout(debounceTimer)
    debounceTimer
      = setTimeout(() => func.apply(context, args), delay)
  }
}

if (predictiveSearch && theme.settings.impulsePredictive === false) {
  openPredictiveSearch.forEach(function (openBtn) {
    openBtn.addEventListener('click', function (event) {
      event.preventDefault()
      predictiveSearch.classList.add('predictive-search--active');
      predictiveSearchOverlay.classList.add('predictive-search__overlay--active');
      document.body.style.overflow = "hidden";
    });
  });

  // closePredictiveSearch.addEventListener('click', function () {
  //   predictiveSearch.classList.remove('predictive-search--active');
  //   predictiveSearchOverlay.classList.remove('predictive-search__overlay--active');
  //   document.body.style.overflow = "auto";
  // });

  predictiveSearchOverlay.addEventListener('click', function () {
    predictiveSearch.classList.remove('predictive-search--active');
    predictiveSearchOverlay.classList.remove('predictive-search__overlay--active');
    document.body.style.overflow = "auto";
  });

  // predictiveSearchInputClear.addEventListener('click', function () {
  //   predictiveSearchInput.value = '';
  //   predictiveSearchInputClear.classList.remove('searchClearQuery--active');
  //   predictiveSearchResults.classList.remove('predictive-search__body--active');
  //   predictiveSearchSuggestions.classList.remove('predictive-search__body--active');
  //   predictiveSearchResults.innerHTML = predictiveSearchSuggestions.innerHTML;
  // });

  predictiveSearchInputs.forEach(predictiveSearchInput => {
    predictiveSearchInput.addEventListener('keydown', debounce(() => {
      if (predictiveSearchInput.value.length > 0) {
        // predictiveSearchInputClear.classList.add('searchClearQuery--active');
  
        fetch(`/search/suggest?q=${predictiveSearchInput.value}&resources[type]=product,collection,article&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,&section_id=predictive-search`)
          .then((response) => {
            if (!response.ok) {
              throw new Error(response.status);
            }
  
            return response.text();
          })
          .then(async (text) => {
            const textDOM = new DOMParser().parseFromString(text, 'text/html');
            const resultsWrapper = textDOM.querySelector('[data-predictive-search-results]');
  
            if (resultsWrapper) {
              predictiveSearchResultWrapper.forEach(predictiveSearchResult => {
                predictiveSearchResult.innerHTML = resultsWrapper.innerHTML;
                predictiveSearchResult.classList.add('predictive-search__body--active');
              });
  
              const predictiveSearchViewAll = document.querySelector('[data-predictive-search-submit-view-all]');
              if (predictiveSearchViewAll) {
                predictiveSearchViewAll.addEventListener('click', function (event) {
                  event.preventDefault();
                  predictiveSearchInput.form.submit();
                });
              }
            }
          })
          .catch((error) => {
            throw error;
          });
      } else {
        // predictiveSearchInputClear.classList.remove('searchClearQuery--active');
        predictiveSearchResultWrapper.forEach(predictiveSearchResult => {
          predictiveSearchResult.innerHTML = '';
        });
      }
    }, 250));
  });
}




/* Set header height */

function setHeaderHeight() {
  const totalHeader = document.getElementById('shopify-section-header');
  const header = totalHeader.querySelector('.header-sticky-wrapper');
  const searchField = totalHeader.querySelector('.mobile-search-field');
  const totalHeaderHeight = totalHeader.offsetHeight + (searchField.hidden ? 0 : searchField.offsetHeight);
  const headerHeight = header.offsetHeight + (searchField.hidden ? 0 : searchField.offsetHeight);

  document.documentElement.style.setProperty('--total-header-height', totalHeaderHeight + 'px');
  document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
}

setHeaderHeight();

// Define the throttle function
function throttle(func, limit) {
    let lastFunc;
    let lastRan;
    return function() {
        const context = this;
        const args = arguments;
        if (!lastRan) {
            func.apply(context, args);
            lastRan = Date.now();
        } else {
            clearTimeout(lastFunc);
            lastFunc = setTimeout(function() {
                if ((Date.now() - lastRan) >= limit) {
                    func.apply(context, args);
                    lastRan = Date.now();
                }
            }, limit - (Date.now() - lastRan));
        }
    };
}

// Wrap setHeaderHeight with throttle
const throttledSetHeaderHeight = throttle(setHeaderHeight, 200);

// Update the event listener to use the throttled function
window.addEventListener('resize', throttledSetHeaderHeight);
document.addEventListener('open-search-mobile', setHeaderHeight);